export const LAYER_KEY__DRAFT_POP_ADJUSTED = 'draftpop_adjusted';
export const LAYER_KEY__DRAFT_NVT_ADJUSTED = 'draftnvt_adjusted';
export const LAYER_KEY__DRAFT_NETWORK_ADJUSTED = 'draftnetwork_adjusted';

export default {
  [LAYER_KEY__DRAFT_POP_ADJUSTED]: {
    layoutState: 'default',
    layerConfig: {
      type: 'symbol',
      id: LAYER_KEY__DRAFT_POP_ADJUSTED,
      sourceLayer: LAYER_KEY__DRAFT_POP_ADJUSTED,
      source: LAYER_KEY__DRAFT_POP_ADJUSTED,
      visibility: 'visible',
      visible: true,
      icons: [
        {
          name: 'symbolPopAdjusted',
          path: '/static/images/mapIcons/pop.png',
        },
      ],
    },
    style: {
      default: {
        layout: {
          'icon-image': 'symbolPopAdjusted',
          visibility: 'none',
          'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.2, 15, 0.4],
          'icon-allow-overlap': true,
        },
      },
    },
    legend: {
      default: {
        name: 'Grobplanung Änderungsanträge',
        unit: '',
        items: [
          {
            color: '#0c1b62',
            name: 'Point of Presence (POP)',
            image: '/static/images/mapIcons/pop.png',
          },
        ],
      },
    },
  },
  [LAYER_KEY__DRAFT_NVT_ADJUSTED]: {
    layoutState: 'default',
    layerConfig: {
      type: 'symbol',
      id: LAYER_KEY__DRAFT_NVT_ADJUSTED,
      sourceLayer: LAYER_KEY__DRAFT_NVT_ADJUSTED,
      source: LAYER_KEY__DRAFT_NVT_ADJUSTED,
      visibility: 'visible',
      visible: true,
      icons: [
        {
          name: 'nvtPhase3',
          path: '/static/images/mapIcons/nvt_phase_3.png',
        },
        {
          name: 'nvtPhase4',
          path: '/static/images/mapIcons/nvt_phase_4.png',
        },
      ],
    },
    style: {
      default: {
        layout: {
          'icon-image': [
            'case',
            ['==', ['get', 'phase'], 3],
            'nvtPhase3',
            ['==', ['get', 'phase'], 4],
            'nvtPhase4',
            '',
          ],
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.3, 15, 0.6],
          visibility: 'none',
        },
      },
    },
    legend: {
      default: {
        name: 'NVT-Standorte Änderungsanträge',
        unit: '',
        items: [
          {
            name: 'Netzverteiler HGF',
            image: '/static/images/mapIcons/nvt_phase_3.png',
          },
          {
            name: 'Netzverteiler DGF',
            image: '/static/images/mapIcons/nvt_phase_4.png',
          },
        ],
      },
    },
  },
  [LAYER_KEY__DRAFT_NETWORK_ADJUSTED]: {
    layoutState: 'default',
    layerConfig: {
      type: 'line',
      id: LAYER_KEY__DRAFT_NETWORK_ADJUSTED,
      sourceLayer: LAYER_KEY__DRAFT_NETWORK_ADJUSTED,
      source: LAYER_KEY__DRAFT_NETWORK_ADJUSTED,
      visibility: 'none',
    },
    style: {
      default: {
        lineColor: [
          'case',
          ['==', ['get', 'phase'], 3],
          '#50e350',
          ['==', ['get', 'phase'], 4],
          '#013220',
          '#2962FF',
        ],
        lineWidth: 1,
      },
    },
    legend: {
      default: {
        name: 'Grobplanung Änderungsanträge',
        unit: '',
        items: [
          {
            color: '#50e350',
            name: 'Netzleitung HGF',
            icon: 'mdi-minus',
            size: '14px',
          },
          {
            color: '#013220',
            name: 'Netzleitung DGF',
            icon: 'mdi-minus',
            size: '14px',
          },
        ],
      },
    },
  },
};